<template>
	<teleport to="body">
		<transition name="fade-slide-down">
			<div
				v-if="showSnackbar"
				role="alert"
				class="pointer-events-none fixed left-0 top-4 z-50 w-full"
			>
				<div class="container mx-auto w-2/5 max-w-screen-sm drop-shadow-lg">
					<slot />
				</div>
			</div>
		</transition>
	</teleport>
</template>

<script setup>
import { computed, ref, watch } from 'vue';

const props = defineProps({
	timeout: { type: Number, default: -1 },
	display: { type: Boolean, default: true },
});

var timeoutId = ref(null);
const timeoutReached = ref(false);
const showSnackbar = computed(() => props.display && !timeoutReached.value);

watch(
	() => props.display,
	() => {
		if (timeoutId.value) {
			clearTimeout(timeoutId.value);
		}

		timeoutReached.value = false;
		if (props.timeout > 0) {
			timeoutId.value = setTimeout(() => (timeoutReached.value = true), props.timeout);
		}
	}
);
</script>

<style scoped>
.fade-slide-down-enter-active,
.fade-slide-down-leave-active {
	transition: all 0.5s;
}

.fade-slide-down-enter-from,
.fade-slide-down-leave-to {
	transform: translateY(-100%);
	opacity: 0;
}
</style>
